import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import CreditCardAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/CreditCardAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';
import PayoutsButton from '../OtherComponents/PayoutsButton';

const CreditCardProccessingStrategy = {
  previewInfo: {
    name: 'Credit cards',
    iconSvg: <CreditCardAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Credit cards',
    category: 'Payments',
    details: (
      <div>
        <a
          href="https://www.creditcards.com/credit-card-news/payment-method-statistics-1276.php"
          target="_blank"
          rel="noreferrer"
        >
          75%
        </a>{' '}
        of homeowners prefer to pay with a credit or debit card, with only 11% wanting to pay in cash.
        <Spacer20 />
        With our payment processing capabilities, you can accept credit or debit cards and get paid 3x faster. One low
        rate for all types of cards: Visa, Mastercard, AMEX and Discover.
        <Spacer20 />
        This feature is integrated into Housecall Pro on both the web and mobile and is the easiest way to get paid.
        There are no dongles to break, you simply use the camera on your phone to snap a card.
      </div>
    ),
    iconSvg: <CreditCardAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/cq65p6t260?autoPlay=false',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    title: 'Housecall Pro Add-on Price',
    description: <div>Fee for processing starting at 2.69% </div>,
    appActionButton: <PayoutsButton appPathName="credit_card_processing" appName="Credit cards" />,
  },
  supportContacts: [],
};

export default CreditCardProccessingStrategy;
